export default {
  mapNumberFromRangeToRange(val, inMin, inMax, outMin, outMax) {
    // Return the lower output value if a division by zero error will occur.
    if (inMin === inMax) return outMin;
    return ((val - inMin) * (outMax - outMin)) / (inMax - inMin) + outMin;
  },
};
